import { useRouter } from 'next/router'
import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  XIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
} from 'react-share'
import { useState } from 'react'
import MessengerIcon from '@components/ItemPage/Details/Important/Buttons/ShareButton/MessengerIcon'

const shareMethods: { label: string; Button: any; Icon: any }[] = [
  { label: 'Facebook', Button: FacebookShareButton, Icon: FacebookIcon },
  {
    label: 'Messenger',
    Button: FacebookMessengerShareButton,
    Icon: MessengerIcon,
  },
  { label: 'X', Button: TwitterShareButton, Icon: XIcon },
  { label: 'Email', Button: EmailShareButton, Icon: EmailIcon },
]

const Content = () => {
  const router = useRouter()
  const shareUrl = `${process.env.NEXT_PUBLIC_URL || ''}${router.asPath}`

  return (
    <div className="mt-2 w-full py-4">
      <div className="w-full flex gap-6 flex-wrap justify-evenly mb-8">
        {shareMethods.map(({ label, Button, Icon }) => (
          <div
            className="flex flex-col gap-1 justify-center items-center flex-wrap"
            key={`share-method-${label}`}
          >
            <Button url={shareUrl}>
              <Icon round />
            </Button>
            <p className="items-center">{label}</p>
          </div>
        ))}
      </div>
      <CopyLinkComponent linkToCopy={shareUrl} />
    </div>
  )
}

const CopyLinkComponent = ({ linkToCopy }: { linkToCopy: string }) => {
  const [isCopied, setIsCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(linkToCopy)
      setIsCopied(true)
      setTimeout(() => setIsCopied(false), 2000) // Reset copied state after 2 seconds
    } catch (err) {
      console.error('Failed to copy!', err)
    }
  }

  return (
    <div className="flex items-center bg-gray-800 rounded-lg overflow-hidden">
      <input
        type="text"
        readOnly
        value={linkToCopy}
        className="p-2 text-sm text-white bg-transparent flex-grow"
        onClick={handleCopy} // Select text when clicking on the input
      />
      <button
        onClick={handleCopy}
        className={`px-4 py-2 bg-blue-500 text-white font-semibold text-sm hover:bg-blue-600 transition-colors duration-300 ease-in-out ${
          isCopied ? 'bg-green-500 hover:bg-green-600' : ''
        }`}
      >
        {isCopied ? 'Copied' : 'Copy'}
      </button>
    </div>
  )
}

export default Content
